import { useTranslation } from 'react-i18next';
import { CellType, ICell, SortType } from '../../../../base';

export const useTableCells = (): ICell[] => {
    const { t } = useTranslation();

    const cells: Array<ICell> = [
        {
            id: 'id',
            headerTitle: t('jobApplicationsTable.applicationId'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'id' },
            isSortable: true,
        },
        {
            id: 'isSaved',
            headerTitle: '',
            type: CellType.IconButton,
            cellFields: {
                iconName: 'isSavedIconName',
                iconColor: 'isSavedIconColor',
                iconSize: 'isSavedIconSize',
                onButtonClick: 'onIsSavedButtonClick',
            },
            isSortable: false,
        },
        {
            id: 'icon',
            headerTitle: '',
            type: CellType.Icon,
            cellFields: {
                iconName: 'iconName',
                iconColor: 'iconColor',
                iconSize: 'iconSize',
            },
            isSortable: false,
        },
        {
            id: 'candidateName',
            headerTitle: t('jobApplicationsTable.candidateName'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'name' },
            isSortable: true,
            sortKey: 'full_name',
        },
        {
            id: 'positionTitle',
            headerTitle: t('jobApplicationsTable.positionTitle'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'title' },
            isSortable: true,
            sortKey: 'job__title',
        },
        {
            id: 'matchScore',
            headerTitle: t('jobApplicationsTable.matchScore'),
            type: CellType.RangeBlocks,
            cellFields: {
                rangeBlockFrom: 'rangeBlockFrom',
                rangeBlockTo: 'rangeBlockTo',
                rangeBlockColor: 'rangeBlockColor',
                notApplicable: 'isLegacy',
            },
            isSortable: true,
        },
        {
            id: 'applicationStatus',
            headerTitle: t('jobApplicationsTable.applicationStatus'),
            type: CellType.Label,
            cellFields: { labelText: 'statusLabel', labelColor: 'statusColor' },
            isSortable: true,
            sortKey: 'status',
        },
        {
            id: 'tags',
            headerTitle: t('jobApplicationsTable.tags'),
            type: CellType.Tags,
            cellFields: {
                objectId: 'id',
                modelName: 'modelName',
                appliedTags: 'appliedTags',
                disabled: 'isLegacy',
            },
            isSortable: false,
        },
        {
            id: 'source',
            headerTitle: t('jobApplicationsTable.source'),
            type: CellType.SingleTextLine,
            cellFields: { text: 'source' },
            isSortable: true,
            sortType: SortType.lexical,
            sortKey: 'referral_source__name',
        },
        {
            id: 'applicationDate',
            headerTitle: t('jobApplicationsTable.applicationDate'),
            type: CellType.DateAndTime,
            cellFields: { text: 'applicationDate' },
            isSortable: true,
            sortKey: 'submission_date',
        },
        {
            id: 'actionMenu',
            headerTitle: '',
            type: CellType.Menu,
            cellFields: { menuActions: 'menuActions' },
        },
    ];
    cells.forEach((cell, index) => {
        cell.columnIndex = index;
    });

    return cells;
};
